import React, { useEffect, useMemo } from "react"
import MovementKeyList from "./MovementKeyList"
import { useVehicleStockMovements } from "hooks/stockHook"
import MovementKeyFilter from "./MovementKeyFilter"
import { useFilteredVehicleOptions } from "hooks/stockFilterHook"
import { useListParams } from "hooks/useListParams"
import { MovementKeyHeader } from "./MovementKeyHeader"
import { useResetParamsOnTabChange } from "hooks/useResetParamsOnTabChange"

const MovementKeyContainer = () => {
  document.title = "Movement Key List"

  // reset url params except 'tab', 'page'
  useResetParamsOnTabChange("key-list")
  // URL search params hook
  const { params, resetParams,setPage, updateParams, hasActiveFilters } = useListParams(
    {
      page: 1,
      search: "",
      movement_type_id: "",
      location_to_id: "",
      movement_by_id: "",
      date_from: "",
      date_to: "",
    }
  )

  // Query params
  const queryParams = useMemo(() => {
    const {
      page = 1,
      per_page = 30,
      search,
      movement_type_id,
      location_to_id,
      movement_by_id,
      date_from,
      date_to,
    } = params

    const q = { page, per_page }

    q.search = search
    q.movement_type_id = movement_type_id
    q.location_to_id = location_to_id
    q.movement_by_id = movement_by_id
    q.date_from = date_from
    q.date_to = date_to

    return q
  }, [
    params.page,
    params.search,
    params.movement_type_id,
    params.location_to_id,
    params.movement_by_id,
    params.date_from,
    params.date_to,
  ])

  const {
    data: movements,
    refetch: handleRefresh,
    isRefetching,
    isLoading: movementFetchLoading,
  } = useVehicleStockMovements(queryParams, params?.tab === "key-list")
  const data = movements?.data || []

  // Options hook
  const { isLoading: optionLoading, raw: rawData } = useFilteredVehicleOptions()

  // Memoize the data to prevent unnecessary re-renders
  const movementTypesData = useMemo(
    () => rawData?.movement_types ?? [],
    [rawData?.movement_types]
  )

  const locationsData = useMemo(
    () => rawData?.locations ?? [],
    [rawData?.locations]
  )

  const employeesData = useMemo(
    () => rawData?.employees ?? [],
    [rawData?.employees]
  )

  const total = data?.total ?? 0

  return (
    <div>
      <div className="mb-3">
        <MovementKeyHeader
          handleRefresh={handleRefresh}
          resetParams={resetParams}
          isRefetching={isRefetching}
          hasActiveFilters={hasActiveFilters}
          total={total}
        />
      </div>
      <MovementKeyFilter
        movementTypesData={movementTypesData}
        employeesData={employeesData}
        locationsData={locationsData}
        optionLoading={optionLoading}
        params={params}
        updateParams={updateParams}
      />
      <MovementKeyList
        loading={movementFetchLoading || isRefetching}
        data={data}
        onPageChange={setPage}
      />
    </div>
  )
}

export default MovementKeyContainer
